/**
 * Normalise un rôle organisation (admin / cashier / both).
 */
export const normalizeRole = (roleName) => {
    if (!roleName) return 'admin';

    if (typeof roleName === 'object') {
        const id = String(roleName.id || '').toLowerCase();
        const name = String(roleName.name || '').toLowerCase();
        if (id === 'cashier' || name.includes('caissier')) return 'cashier';
        if (id === 'admin' || name.includes('administr')) return 'admin';
        return normalizeRole(name || id);
    }

    const normalized = String(roleName).toLowerCase().trim();
    if (normalized === 'both') return 'both';
    if (normalized.includes('caissier') || normalized === 'cashier') return 'cashier';
    if (normalized.includes('admin') || normalized === 'administrator' || normalized === 'admin') {
        return 'admin';
    }
    return normalized;
};

/** Vrai si la session courante est en mode administrateur pour l'organisation. */
export const isOrganizationAdmin = (organization) =>
    normalizeRole(organization?.selectedRole || organization?.role) === 'admin';
